module.exports = __webpack_public_path__ + "media/LP_内覧モード.c5caaad4.mp4";